import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Home from "../components/Home/Home";
import analytics from "../services/firebase";
import { logEvent } from "firebase/analytics";
import Linktree from "../shared/components/Linktree/Linktree";

const RoutesListener = () => {
  const location = useLocation();

  useEffect(() => {
    logEvent(analytics, "page_view", {
      page_location: "https://myhomedelcastilho.web.app/",
      page_path: "/",
      page_title: "Home",
    });
  }, [location]);

  return <></>;
};

export const Rotas = ({ pathname }) => {
  return (
    <Router>
      <div className="App">
        <RoutesListener />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/link" element={<Linktree />} />
        </Routes>
      </div>
    </Router>
  );
};
